import { useEffect } from 'react';

/**
 * Reset the window scroll back to the top when the identifier changes
 * @param identifier
 */
const useResetScroll = (identifier: any) => {
  useEffect(
    () => {
      window.scrollTo(0, 0);
    },
    [identifier]
  );
};

export default useResetScroll;
